/* unplugin-vue-components disabled */import script from "./MultiComponents.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiComponents.vue?vue&type=script&setup=true&lang=ts"

import "./MultiComponents.vue?vue&type=style&index=0&id=66a9c7b7&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a9c7b7"]])

export default __exports__